import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BusinessActivitySurvey } from '@shared/models/data-model';
import { RegistrationService } from '@shared/services/registration.service';

export const businessActivitySurveyResolver: ResolveFn<BusinessActivitySurvey> = (route, state) => {
    return inject(RegistrationService).getBusinessActivitySurvey();
};
